import Axios from "../Axios";

export const fetchCartItems = async () => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  if (token) {
    const response = await Axios.get("/purchases/cart", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  }
};

export const addCartItem = async ({ productId }) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  if (token) {
    const response = await Axios.post(
      "/purchases/cart",
      { productId, count: 1 },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  }
};

export const removeCartItem = async ({ productId }) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];

  if (token) {
    const response = await Axios.post(
      "/purchases/cart",
      { productId, count: -1 },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return response.data;
  }
};
